
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"15","viewBox":"0 0 16 15"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"download","transform":"translate(0 -1)"}},[_c('path',{attrs:{"id":"Path_462","data-name":"Path 462","d":"M9,8V1H7V8H4.6L8,12l3.4-4Z","fill":"#24439c"}}),_c('path',{attrs:{"id":"Path_463","data-name":"Path 463","d":"M15,16H1a.945.945,0,0,1-1-1V6A.945.945,0,0,1,1,5H4V7H2v7H14V7H12V5h3a.945.945,0,0,1,1,1v9A.945.945,0,0,1,15,16Z","fill":"#98a9b3"}})])])
          )
        }
      }
    